<gt-header></gt-header>
<ion-content>
  <div
    [style.backgroundImage]="'url(' + backgroundImageUrl + ')'"
    class="custom-background w-full h-full bg-no-repeat bg-cover bg-center p-4 flex flex-col gap-4 items-center relative"
  >
    <div class="flex flex-col items-center mt-10 gap-8">
      <img src="/assets/img/gt-profile.png" />
      <h1 class="text-center text-2xl">{{ 'ONBOARDING.PRE-REGISTER.TITLE' | transloco }}</h1>
      <div class="bg-card flex flex-col gap-4 items-center p-4 text-center">
        <div class="m-0 text-destacadoM">{{'ONBOARDING.PRE-REGISTER.REGISTERED_TITLE' | transloco}}</div>
        <p>{{'ONBOARDING.PRE-REGISTER.REGISTERED_DESCRIPTION' | transloco}}</p>
        <gt-button routerLink="/onboarding/login" [queryParams]="{redirect: true}"
          >{{'ONBOARDING.REGISTER.SIGN_IN' | transloco}}</gt-button
        >
      </div>
      <div class="bg-card flex flex-col gap-4 items-center p-4 text-center">
        <div class="m-0 text-destacadoM">{{'ONBOARDING.PRE-REGISTER.NO_REGISTERED_TITLE' | transloco}}</div>
        <p>{{'ONBOARDING.PRE-REGISTER.NO_REGISTERED_DESCRIPTION' | transloco}}</p>
        <gt-button routerLink="/onboarding/register/form"
          >{{'ONBOARDING.REGISTER.BUTTON.REGISTER' | transloco}}</gt-button
        >
      </div>
    </div>
  </div>
</ion-content>
